import { Modal } from "@truevault/aquilo";
import React, { useEffect, useState } from "react";
import { subscribeToBlockedActions } from "./editModeState";

type EditModeBlockedModalProps = {
  onSwitchToEditMode: () => void;
};

export const EditModeBlockedModal = ({ onSwitchToEditMode }: EditModeBlockedModalProps) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    return subscribeToBlockedActions(() => setShowModal(true));
  }, []);

  const closeModal = () => setShowModal(false);

  const switchToEditMode = () => {
    closeModal();
    onSwitchToEditMode();
  };

  if (!showModal) {
    return null;
  }

  return (
    <Modal
      title="You're in read-only mode"
      body="Global admins start in read-only mode. Switch to edit mode for 15 minutes before making changes."
      firstButton="Switch to edit mode"
      firstButtonColor="primary"
      secondButton="Dismiss"
      secondButtonColor="tertiary"
      showOverlay={true}
      closeOnOverlayClick={true}
      onFirstButtonClick={switchToEditMode}
      onSecondButtonClick={closeModal}
      onClose={closeModal}
    />
  );
};
